import styled from "styled-components";
import { Box, Button } from "@material-ui/core";

export const CustomTwoSelects = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-width: 350px;
    label {
        font-size: 15px;
    }
    > div {
        flex: 1;
    }
    #first-select {
        margin-right: 30px;
    }
    @media only screen and (max-width: 767px) {
        flex-direction: column;
        min-width: auto;
        #first-select {
            margin-right: 0px;
        }
    }
`;
